/* import __COLOCATED_TEMPLATE__ from './brand-signup-about-you.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action, getProperties } from '@ember/object';
import { debounce } from '@ember/runloop';
import { task } from 'ember-concurrency';
import { object, string } from 'yup';
import { validateSchema } from 'sh-www/utils/validators';

const CLASS_NAME = 'GLM-brand-signup-about-you';

const SCHEMA = object({
  'first_name': string()
    .required('Please enter your first name')
    .min(2, 'Please enter your first name'),

  'last_name': string()
    .required('Please enter your last name')
    .min(2, 'Please enter your last name'),

  'phone_number': string()
    .transform((x) => x || undefined)
    .required('Please enter your phone number')
    .min(7, 'Your phone number must be at least 7 digits'),
  'profile_image': object().required('You must upload a profile picture'),
});

class BrandSignupAboutYou extends Component {
  @service('commands/user-commands') userCommandService;
  @service session;

  @tracked first_name = this.session.currentUser.firstName ?? '';
  @tracked last_name = this.session.currentUser.lastName ?? '';
  @tracked phone_number = this.session.currentUser.phone ?? '';
  /** @var {Image|null} */
  @tracked profile_image = this.storedProfileImage;
  @tracked errors = null;
  @tracked waveTrigger = false;

  get className() {
    return CLASS_NAME;
  }

  get submitDisabled() {
    return (
      this.first_name.length < 2 ||
      this.last_name.length < 2 ||
      this.phone_number.length < 1 ||
      this.profile_image === null ||
      this.updateUserInfoTask.isRunning
    );
  }

  get shouldSubmitShine() {
    return !this.submitDisabled;
  }

  get storedProfileImage() {
    const { image } = this.session.currentUser;
    if (image?.cloudId && !image.isPlaceholderImage) {
      return image;
    }

    return null;
  }

  @action
  setFormField(field, value) {
    this[field] = value;

    if (field === 'last_name') {
      debounce(this, this.triggerWave, 750);
    }

    if (this.errors?.[field]) {
      this.errors = { ...this.errors, [field]: undefined };
    }
  }

  @action
  triggerWave() {
    this.waveTrigger = true;
  }

  /**
   * @param {Image|null} image
   */
  @action
  updateProfileImage(image) {
    this.profile_image = image;
  }

  @task
  *updateUserInfoTask(e) {
    e.preventDefault();

    const [_, validationErrors = null] = validateSchema(
      getProperties(this, Object.keys(SCHEMA.fields)),
      SCHEMA,
    );

    this.errors = validationErrors;

    if (this.errors) {
      return;
    }

    try {
      yield this.args.updateUserInfo({
        first_name: this.first_name,
        last_name: this.last_name,
        phone: this.phone_number,
      }, {
        image: this.profile_image,
      });
    } catch(error) {
      this.errors = {
        first_name: error.errors?.['first_name']?.[0],
        last_name: error.errors?.['last_name']?.[0],
        phone_number: error.errors?.['phone']?.[0],
        profile_image: error.errors?.['profile_image']?.[0],
      };
    }
  }
}

export default BrandSignupAboutYou;
